"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrExternalMedia = void 0;
const react_1 = __importDefault(require("react"));
const fdr_media_image_1 = require("./fdr-media-image");
const fdr_media_styles_1 = require("./fdr-media.styles");
function FdrExternalMedia(props) {
    const { className, preview, resource, lazy } = props;
    return (react_1.default.createElement(fdr_media_styles_1.ExternalMediaLink, { className: className, href: resource },
        react_1.default.createElement(fdr_media_image_1.FdrMediaImage, { image: preview, lazy: lazy })));
}
exports.FdrExternalMedia = FdrExternalMedia;
//# sourceMappingURL=fdr-external-media.js.map